export default __webpack_public_path__ + "static/media/fontello.9e7ba0b9.svg";